import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class DrawAction extends AbstractProvidedClass {
    constructor(provider, shape) {
        super(provider);
        this.shape = shape;
    }

    finish() {
        this.elements.add(this.shape);
        window.posthog?.capture('planner_element_created', {
            element_type: this.shape.type,
            planner_version: 'v1',
        });
        this.actions.finish();
    }

    undo() {
        this.elements.delete([this.shape]);
    }

    redo() {
        this.elements.add(this.shape);
    }
}
